<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
            <p><strong>诺辰生物诚邀英才，以科技之力守护健康</strong></p>
           <p>诺辰生物是博奥润康旗下专注于二、三类医疗器械与DNA检测试剂盒的研发与生产的创新型技术企业。我们拥有3000m²标准化GMP厂房及万级、十万级洁净生产与实验环境，致力于通过持续创新，为医疗机构提供精准高效的医疗产品。</p>
           <p>我们正在寻找怀揣热忱、追求卓越的你，加入我们的研发、生产与管理团队。在这里，你将直接参与前沿产品的开发与转化，在专业的平台中快速成长，与我们一同践行“创新驱动发展，科技服务健康”的使命，为推动人类健康进步贡献切实力量。</p>
           <p><strong>如果你相信科技的价值，并渴望将自己的专业转化为有社会影响力的成果，请加入我们，共创未来！</strong></p>
          </div>
          <div class="textCenter" style="padding:100px 0;">
            <el-button type="primary" @click="golink('https://www.zhipin.com/gongsi/job/a3c5ba1e9192ae8d0Xd83d67GQ~~.html?ka=all-jobs-hot')">点击前往「诺辰生物招聘」-BOSS直聘 (zhipin.com) <i
                class="fa fa-fw fa-arrow-right"></i></el-button>
          </div>
          <!-- <div v-if="pageContent" v-html="pageContent.content"></div>
          <div v-else>
            <p>页面暂无内容</p>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi } from '@/api'

export default {
  name: 'Join',
  data() {
    return {
      pageContent: ''
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(3)
  },
  methods: {
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    }, golink(e){
      let url =e
      window.open(url, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;


  img {
    max-width: 80%;
  }


}
</style>